import {
  knowYourRightsMenu,
  knowYourRightsFooterMenu,
  topMenu,
  productsMenu,
  companyMenu,
  supportMenu,
  legalMenu,
  imprintMenu,
} from "./menus";
import type { MenuProps, MenuExtendedProps } from "./menus.d";

export {
  knowYourRightsMenu,
  knowYourRightsFooterMenu,
  topMenu,
  productsMenu,
  companyMenu,
  supportMenu,
  legalMenu,
  imprintMenu,
  MenuProps,
  MenuExtendedProps,
};
